import { useContext, useEffect, useState } from "react";
import { UseFormGetValues, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { useDebouncedCallback } from "use-debounce";

import useFetch from "../useFetch";
import { AuthContext } from "src/context/authContext";
// import { addPatientDetails } from "src/helpers/addCase";

import { APIEndpoints } from "src/types/apiTypes";
import { AddCaseProps } from "src/pages/addCase/types";
import { PracticeDropdownResponse, ProviderDropdownResponse } from "src/components/caseStepTwo/types";



const useReferringPracAndDocFunc = (
  getValues: UseFormGetValues<AddCaseProps>, watch: UseFormWatch<AddCaseProps>, 
  setValue: UseFormSetValue<AddCaseProps>
) => {
  const [firstReferringPracticeId] = useState(getValues("doctor_attributes.referring_practice_id"));

  const { userData } = useContext(AuthContext)

  const iAm = watch("doctor_attributes.i_am");
  const referringPracticeId = watch("doctor_attributes.referring_practice_id")



  const { loading: isPracAPILoading, data: practiceListing, mutate: getPracticeListing, removeErrorAndData: clearPracticeListing } =
    useFetch<PracticeDropdownResponse>(APIEndpoints.PRACTICE_DROPDOWN, {}, {}, false)

  const getListingBySearchQuery = (searchQuery: string, shouldCalledImmediately: boolean = false, practiceId: number = 0): void => {
    if (shouldCalledImmediately) {
      if (practiceId)
        getPracticeListing({}, {}, { practice_id: practiceId })
      else  
        getPracticeListing({}, {}, { search_query: searchQuery })
    }

    if (searchQuery.length >= 3) {
      getPracticeListing({}, {}, { search_query: searchQuery })
    }
  }

  const debouncedPracticeSearch = useDebouncedCallback(getListingBySearchQuery, 1500)



  const { data: globalDoctorsApiResponse, mutate: getGlobalDoctorsListing } =
    useFetch<ProviderDropdownResponse>(APIEndpoints.PROVIDER_DROPDOWN);

  /** @second */
  useEffect(() => {
    if (referringPracticeId && practiceListing) {
      // if (firstReferringPracticeId !== referringPracticeId)
      //   addPatientDetails(setValue, );

      const globalDoctorParams = {
        practice_id: referringPracticeId,
      };
      getGlobalDoctorsListing(null, null, globalDoctorParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referringPracticeId, practiceListing]);

  const getReferringDoctorListingByPracticeId = (pracId: number) => {
    const globalDoctorParams = {
      practice_id: pracId,
    };
    getGlobalDoctorsListing(null, null, globalDoctorParams);
  }


  useEffect(() => {
    if (practiceListing && practiceListing.data && practiceListing.data.length > 0) {
      if (referringPracticeId && referringPracticeId === firstReferringPracticeId) {
        const selection = practiceListing.data.find((prac) => prac.id === referringPracticeId)
        if (!selection)
          getPracticeListing(null, null, { practice_id: referringPracticeId });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referringPracticeId, practiceListing])


  useEffect(() => {
    if (userData && ["Practice", "Contact"].includes(userData.ref_type)) {
      if (["Referring Facility", "Referring Provider", "Referring and Treating Facility"].includes(iAm)) {
        if (practiceListing && practiceListing.data && practiceListing.data.length > 0) {
          setValue("doctor_attributes.referring_practice_id", practiceListing.data[0].id)
          getReferringDoctorListingByPracticeId(practiceListing.data[0].id)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceListing, iAm])


  useEffect(() => {
    if (userData && ["GlobalDoctor"].includes(userData.ref_type))
      if (["Referring Provider"].includes(iAm) && referringPracticeId) {
        if (globalDoctorsApiResponse && globalDoctorsApiResponse.data && globalDoctorsApiResponse.data.length > 0) {
          setValue("doctor_attributes.referring_doctor_id", globalDoctorsApiResponse.data[0].id)
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalDoctorsApiResponse, iAm])


  // useEffect(() => {
  //   if (iAm && ["Referring Facility", "Referring and Treating Facility"].includes(iAm)) {
  //     if (practiceListing && practiceListing.data && practiceListing.data.length > 0) {
  //       if (userData && userData.ref_type !== "Organization")
  //         setValue("doctor_attributes.referring_practice_id", practiceListing.data[0].id)

  //       const globalDoctorParams = {
  //         practice_id: practiceListing.data[0].id,
  //       };
  //       getGlobalDoctorsListing(null, null, globalDoctorParams);
  //     } else {
  //       getPracticeListing()
  //     }
  //   } else if (
  //     getValues("doctor_attributes.referring_practice_id") && 
  //     typeof getValues("doctor_attributes.referring_practice_id") === "number"
  //   ) {
  //     if (!practiceListing) {
  //       const practiceId = getValues("doctor_attributes.referring_practice_id")
  //       getPracticeListing(null, null, { practice_id: practiceId })
  //     }
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [iAm, practiceListing])


  // useEffect(() => {
  //   if (["Referring Provider"].includes(iAm))
  //     getPracticeListing()
  //   else
  //     clearPracticeListing()

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [iAm])


  // useEffect(() => {
  //   if (globalDoctorsApiResponse && globalDoctorsApiResponse.data && globalDoctorsApiResponse.data.length > 0) {
  //     if (["Referring Provider"].includes(iAm) && userData && userData.ref_id) {
  //       const selectedDoc = globalDoctorsApiResponse.data.find((doc) => doc.id === userData.ref_id)

  //       if (selectedDoc) {
  //         setValue("doctor_attributes.referring_doctor_id", selectedDoc.id)
  //       }
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [globalDoctorsApiResponse])


  return { 
    isPracAPILoading, practiceListing, globalDoctorsApiResponse, 
    getPracticeListing: debouncedPracticeSearch, clearPracticeListing,
    getReferringDoctorListingByPracticeId
  }
}

export default useReferringPracAndDocFunc
